<template>
  <div>


    <v-timeline size="10" dense v-if="customer">
      <v-timeline-item
          dense
          color="grey"
          small
          class="pa-0"
      >
        <v-list-item dense class="pa-0 ma-0 border-bottom">
          <v-list-item-content class="pa-0 ma-0">
            <v-list-item-title class=" text-h6 font-weight-light">
              {{ customer.name }}
            </v-list-item-title>
            <v-list-item-subtitle><small>Name</small></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-timeline-item>

      <v-timeline-item
          dense
          color="grey"
          small
          class="mt-3"

      >
        <v-list-item dense class="pa-0 border-bottom">
          <v-list-item-content class="pa-0 ma-0">
            <v-list-item-title class="text-h6 font-weight-light">
              {{ customer.email }}
            </v-list-item-title>
            <v-list-item-subtitle><small>Email</small></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-timeline-item>


      <v-timeline-item
          dense
          color="grey"
          small
          class="mt-3"

      >
        <v-btn
            rounded
            block
            color="blue darken-4"
            depressed
            x-large
            dark
            :loading="loading"
            @click="getLink"
        >Manage Billing<sup>
          <v-icon x-small>mdi-open-in-new</v-icon>
        </sup>
        </v-btn>
      </v-timeline-item>


    </v-timeline>

  </div>

</template>

<script>
export default {
  name: "StripeCustomer",
  data() {
    return {
      customer: null,
      loading: false
    }
  },
  methods: {
    getCustomer() {
      axios.get("/api/stripe/customer")
          .then(res => {
            this.customer = res.data;
          })
    },
    getLink() {
      this.loading = true;
      axios.get("/api/stripe/billing-link")
          .then(res => {
            console.log(res.data)
            this.loading = false;

            window.open(res.data.original);

          })
    }
  },
  mounted() {

    this.getCustomer();
  }
}
</script>

<style scoped>

</style>